import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@app/services';

/**
 * Pipe puro reativo ao idioma via signal.
 * Lê `currentLanguage()` dentro do transform para que o Angular zoneless
 * reavalie a tradução quando o idioma mudar, sem `pure: false`.
 */
@Pipe({
  name: '_translate',
  pure: true,
  standalone: false,
})
export class TranslatePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  public transform(value: string): string {
    if (!value) {
      return '';
    }
    this.translateService.currentLanguage();
    return this.translateService.translate(value);
  }
}
